import { MonitoringActionProperties } from 'models';
import { MonitoringAlarmProperties } from 'models/monitoring-alarm';
import { ACTIONS_TYPES } from 'redux/helper';
import { service } from 'services';
import { basicCRUDAction, hotGetAction } from 'utils';

export default {
  action: {
    getAll: async (isPassiveLoading = false) => hotGetAction({
      action: ACTIONS_TYPES.MONITORING.ACTION.GET_ALL,
      apiResult: service.monitoring.action.getAll(),
      isRetrieveItems: true,
      isPassiveLoading,
    }),

    create: async (properties = new MonitoringActionProperties()) => basicCRUDAction({
      action: ACTIONS_TYPES.MONITORING.ACTION.CREATE,
      apiResult: service.monitoring.action.create(properties),
    }),

    get: async ({ id }) => hotGetAction({
      action: ACTIONS_TYPES.MONITORING.ACTION.GET,
      apiResult: service.monitoring.action.get({ id }),
    }),

    update: async ({ id, properties = new MonitoringActionProperties() }) => basicCRUDAction({
      action: ACTIONS_TYPES.MONITORING.ACTION.UPDATE,
      apiResult: service.monitoring.action.update({ id, properties }),
    }),

    delete: async ({ id }) => basicCRUDAction({
      action: ACTIONS_TYPES.MONITORING.ACTION.DELETE,
      apiResult: service.monitoring.action.delete({ id }),
    }),

    getAllExecutions: async ({ actionId }) => hotGetAction({
      action: ACTIONS_TYPES.MONITORING.ACTION.GET_ALL_EXECUTIONS,
      apiResult: service.monitoring.action.getAllExecutions({ actionId }),
      isRetrieveItems: true,
    }),

    getExecution: async ({ actionId, executionId }) => hotGetAction({
      action: ACTIONS_TYPES.MONITORING.ACTION.GET_EXECUTION,
      apiResult: service.monitoring.action.getExecution({ actionId, executionId }),
    }),
  },

  alarm: {
    getAll: async () => hotGetAction({
      action: ACTIONS_TYPES.MONITORING.ALARM.GET_ALL,
      apiResult: service.monitoring.alarm.getAll(),
      isRetrieveItems: true,
    }),

    create: async (properties = new MonitoringAlarmProperties()) => basicCRUDAction({
      action: ACTIONS_TYPES.MONITORING.ALARM.CREATE,
      apiResult: service.monitoring.alarm.create(properties),
    }),

    get: async ({ id }) => hotGetAction({
      action: ACTIONS_TYPES.MONITORING.ALARM.GET,
      apiResult: service.monitoring.alarm.get({ id }),
    }),

    update: async ({ id, properties = new MonitoringAlarmProperties() }) => basicCRUDAction({
      action: ACTIONS_TYPES.MONITORING.ALARM.UPDATE,
      apiResult: service.monitoring.alarm.update({ id, properties }),
    }),

    delete: async ({ id }) => basicCRUDAction({
      action: ACTIONS_TYPES.MONITORING.ALARM.DELETE,
      apiResult: service.monitoring.alarm.delete({ id }),
    }),

    getAllTransitions: async ({ alarmId }) => hotGetAction({
      action: ACTIONS_TYPES.MONITORING.ALARM.GET_ALL_TRANSITIONS,
      apiResult: service.monitoring.alarm.getAllTransitions({ alarmId }),
      isRetrieveItems: true,
    }),

    getTransition: async ({ alarmId, transitionId }) => hotGetAction({
      action: ACTIONS_TYPES.MONITORING.ALARM.GET_TRANSITION,
      apiResult: service.monitoring.alarm.getTransition({ alarmId, transitionId }),
    }),
  },
};
